
import { defineComponent, ref } from 'vue';
import { formatTime, newDate } from '@toy/utils';
import { jumpDays } from '@/core/utils/index';
import { useList } from '@/hooks/use-list';
import {
  getMessageList,
  messageRetry,
} from '@/api/message-center';
import type { IMessagePageReq, IMessagePageListItem, IMessageRetryReq } from '@/api/message-center/type.d';
import { ElMessage } from 'element-plus';
import { useCalendarRange } from './composables/useCalendarRange';
import usePermissionConfig from './use-permission-config';

export default defineComponent({
  components: {

  },
  setup() {
    const selectedKeys = ref<string[]>([]);

    // 初始化的发送时间:[发送起点时间,发送终止时间]
    const endCreatedTime = `${formatTime(newDate())}`;
    const startCreatedTime = `${jumpDays(endCreatedTime, -7)}`;
    const {
      params,
      tableTotal,
      tableData,
      tableLoading,
      handleSearch,
      handleReset,
      handleSizeChange,
      handleCurrentChange,
    } = useList<IMessagePageListItem, IMessagePageReq>({
      request: {
        api: getMessageList,
        params: {
          messageId: '',
          status: '',
          executeService: '',
          indexInfo: '',
          configCode: '',
          exchange: '',
          queue: '',
          routing: '',
          createdTime: [startCreatedTime, endCreatedTime],
          pageNum: 1,
          pageSize: 10,
        },
        handleParams(paramsObj) {
          selectedKeys.value = [];
          [
            paramsObj.startCreatedTime = startCreatedTime,
            paramsObj.endCreatedTime = endCreatedTime,
          ] = paramsObj.createdTime || [];
          paramsObj.startCreatedTime = `${
            formatTime(paramsObj.startCreatedTime, 'YYYY-MM-DD')
          } 00:00:00`;
          paramsObj.endCreatedTime = `${
            formatTime(paramsObj.endCreatedTime, 'YYYY-MM-DD')
          } 23:59:59`;
          delete paramsObj.createdTime;
          return paramsObj;
        },
      },
    });

    const {
      calendarChange,
      disabledDate,
      createdTimeChange,
    } = useCalendarRange(params);

    const handleSelectionChange = (lists: IMessagePageListItem[]) => {
      selectedKeys.value = lists.map(item => item.messageId);
    };

    const messageRetryFn = async (messageIds: IMessageRetryReq['messageIds']) => {
      await messageRetry({
        messageIds,
      });
      ElMessage.success('重试成功');
      handleSearch(params.value.pageNum as number);
    };
    const handleBatchRetry = async () => {
      if (selectedKeys.value.length) {
        await messageRetryFn(selectedKeys.value);
      }
    };
    const handleMessageRetry = (row: IMessagePageListItem) => {
      messageRetryFn([row.messageId]);
    };

    const init = () => {
      handleSearch();
    };

    init();

    const permissionConfig = usePermissionConfig();

    return {
      params,
      tableTotal,
      tableData,
      tableLoading,
      handleSearch,
      handleReset,
      handleSizeChange,
      handleCurrentChange,
      handleSelectionChange,
      handleBatchRetry,
      handleMessageRetry,
      calendarChange,
      disabledDate,
      createdTimeChange,
      permissionConfig,
    };
  },
});
